export const BenefitExpirationTypeEnum = {
  ONE_TIME: "one time",
  MONTH: "month",
  VOUCHER: "voucher"
};
